import { Box, Divider } from '@mui/material'
import styles from './index.module.scss'

/** @param {{ header: import('react').ReactNode }} props */
export function FloatingMenuPopoverHeader({ header }) {
  if (!header) return null
  return (
    <>
      <Box className={styles.headerSlot}>{header}</Box>
      <Divider className={styles.headerDivider} />
    </>
  )
}
